import { withBreadCrumbs } from "lego-gui-lib";
import * as React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Route, RouteComponentProps, Switch } from "react-router";
import { Redirect } from "react-router-dom";

export interface TabData {
  label: string;
  icon?: any;
  path: string;
  Element: JSX.Element;
  if?: (ctx?: any) => boolean;
}

export interface TabContentProps {
  baseUrl: string;
  tabs: TabData[];
}

export const TabContent: FC<TabContentProps> = props => {
  const i18n = useTranslation();
  const { baseUrl, tabs } = props;

  return (
    <Switch>
      {tabs.map(tab => {
        const Component = tab.Element;
        return (
          <Route
            key={tab.path}
            path={baseUrl + tab.path}
            render={(props: RouteComponentProps) => {
              return withBreadCrumbs(
                { to: baseUrl + tab.path, children: i18n.t(tab.label) },
                Component
              );
            }}
          />
        );
      })}
      <Redirect to={baseUrl + tabs[0].path} />
    </Switch>
  );
};
